<template>
  <header class="nav-bar-container">
    <nav ref="nav" class="nav" aria-label="Primary navigation">
      <router-link class="nav-brand" to="/" aria-label="Pi Teams home" @click="closeNav">
        <img class="nav-brand-mark" src="@/assets/icons/eight-nine.png" alt="">
        <span class="nav-brand-label nav-brand-label--desktop">Teams</span>
        <span class="nav-brand-label nav-brand-label--mobile">{{ mobileTitle }}</span>
      </router-link>
      <button class="nav-toggle" type="button" :aria-expanded="String(isOpen)" aria-controls="primary-navigation" aria-label="Toggle navigation" @click="toggleNav"><span></span><span></span></button>
      <div id="primary-navigation" class="nav-links" :class="{ 'is-open': isOpen }">
        <router-link :to="pages[0].to" @click="closeNav">{{ pages[0].name }}</router-link>
        <a
          href="#about"
          :class="{ 'is-active': isCollectiveVisible }"
          @click.prevent="goToSection('about')"
        >The Collective</a>
        <a
          href="#ecosystem"
          :class="{ 'is-active': isEcosystemVisible }"
          @click.prevent="goToSection('ecosystem')"
        >Ecosystem</a>
        <router-link v-for="page in pages.slice(1)" :key="page.index" :to="page.to" @click="closeNav">{{ page.name }}</router-link>
        <a
          href="#reach-us"
          :class="{ 'is-active': isReachUsVisible }"
          @click.prevent="goToSection('reach-us')"
        >Reach Out</a>
      </div>
    </nav>
  </header>
</template>

<script>
import pagesData from '@/data/pages.json';

export default {
  data() {
    return {
      isOpen: false,
      isCollectiveVisible: false,
      isEcosystemVisible: false,
      isReachUsVisible: false,
      collectiveObserver: null,
      ecosystemObserver: null,
      reachUsObserver: null,
      pages: pagesData.pages,
      mobileTitle: pagesData.titles[0],
    };
  },

  mounted() {
    this.shuffleMobileTitle();
    this.$nextTick(() => this.observeHomeSections());
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
  },

  beforeUnmount() {
    this.collectiveObserver?.disconnect();
    this.ecosystemObserver?.disconnect();
    this.reachUsObserver?.disconnect();
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
  },

  watch: {
    $route() {
      this.$nextTick(() => this.observeHomeSections());
    },
  },

  methods: {
    toggleNav() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen) this.shuffleMobileTitle();
    },
    closeNav() {
      this.isOpen = false;
    },
    goToSection(sectionId) {
      this.closeNav();

      if (this.$route.path !== '/') {
        this.$router.push({ path: '/', hash: `#${sectionId}` });
        return;
      }

      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    },
    observeHomeSections() {
      this.observeSection('about', 'isCollectiveVisible', 'collectiveObserver');
      this.observeSection('ecosystem', 'isEcosystemVisible', 'ecosystemObserver');
      this.observeSection('reach-us', 'isReachUsVisible', 'reachUsObserver');
    },
    observeSection(sectionId, visibilityKey, observerKey) {
      this[observerKey]?.disconnect();

      const section = document.getElementById(sectionId);
      if (!section || !('IntersectionObserver' in window)) {
        this[visibilityKey] = false;
        return;
      }

      this[observerKey] = new IntersectionObserver(([entry]) => {
        this[visibilityKey] = entry.isIntersecting;
      }, {
        // The fixed navigation should not count as visible section area.
        rootMargin: '-80px 0px -35% 0px',
        threshold: 0,
      });

      this[observerKey].observe(section);
    },

    handleClickOutside(event) {
      if (this.isOpen && this.$refs.nav && !this.$refs.nav.contains(event.target)) {
        this.closeNav();
      }
    },

    handleKeydown(event) {
      if (event.key === 'Escape') this.closeNav();
    },

    shuffleMobileTitle() {
      const { titles } = pagesData;
      this.mobileTitle = titles[Math.floor(Math.random() * titles.length)];
    },
  },

};
</script>
